export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  details: (id: string) => [...userKeys.all, id] as const,
  chatBalance: (id: string) => [...userKeys.all, 'chat-balance', id] as const,
};
